import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import dog from 'components/MainPage/Assents/icon/midleDog.svg';
import s from '../subcard.module.scss';
export const UserInfo = () => {
    const { t } = useTranslation('userBooking');
    return (_jsxs("div", Object.assign({ className: s.user_info }, { children: [_jsx("p", Object.assign({ className: s.user_info_item }, { children: t('travelOptionForWork') })), _jsx("p", Object.assign({ className: s.user_info_item }, { children: t('travelOptionMediumDog') })), _jsx("div", Object.assign({ className: s.user_info_icon }, { children: _jsx("img", { src: dog, alt: " animal" }) }))] })));
};
